module.exports = __webpack_public_path__ + "img/158.a12b7122.jpg";